import axios from "axios";
import userStorage from "../storages/userStorage";

export enum ApiEndpoints {
  Orders = '/api/orders',
  Drones = '/api/drones',
  DronesMaxId = '/api/drones/max-id',
  SprBrands = '/api/spr/brand',
  Dictionary = '/api/dictionary',
  OrderStats = '/api/orders/stats',
  Items = '/api/item',
  SprPartTypes = "/api/spr/part-types",
  Store = '/api/store',
  Login = '/api/auth/login',
}

axios.defaults.withCredentials = true;

console.log('cookies', document.cookie.split(';').map((cookie) => cookie.trim()));

export function get<T>(url: ApiEndpoints | string, data: Record<string, any> | null = null, config: any = {}): Promise<T | null> {
  const params = Object.entries(data || {});
  const arrayValues: [string, string][] = [];
  for (const param of params) {
    if (param[1] instanceof Array) {
      for (const value of param[1]) {
        arrayValues.push([`${param[0]}[]`, value]);
      }
      continue;
    }
    if (typeof param[1] === 'boolean') {
      arrayValues.push([param[0], param[1] ? 'true' : 'false']);
      continue;
    }
    arrayValues.push(param as [string, string]);
  }
  const realParams = arrayValues.filter((param) => param[1] !== null || param[1] !== undefined || param[1] !== '');
  console.log('mi params', data, realParams)
  const realUrl = data ? `${url}?${new URLSearchParams(realParams).toString()}` : url;

  return axios
    .get<T>(realUrl,
    {
      ...config,
      headers: {
        ...config.headers,
      },
    },
  )
    .then((response) => {
      return response.data
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        userStorage.setNeedLogIn()
      }
      console.error(error);
      return null;
    });
}

export async function post<R, T>(url: ApiEndpoints | string, data: R, config: any = {}): Promise<T | null> {
  try {
    const response = await axios.post<T>(url, data,
      {
        ...config,
        headers: {
          ...config.headers,
        },
      },
    );

    if (!response) {
      throw new Error("Failed to post data");
    }

    return response.data;
  } catch (error) {
    return null;
  }
}

export function put<R, T>(url: string, data: R, config: any = {}): Promise<T | null> {
  return axios.put<T>(url, data,
    {
      ...config,
      headers: {
        ...config.headers,
      },
    },
  ).then((response) => {
    return response.data
  })
    .catch((error) => {
      if (error.response?.status === 401) {
        userStorage.setNeedLogIn()
      }
      console.error(error);
      return null;
    });
}

export function del<T>(url: string, config: any = {}): Promise<T | null> {
  return axios.delete(url,
    {
      ...config,
      headers: {
        ...config.headers,
      },
    },
  ).then((response) => {
    return response.data
  })
    .catch((error) => {
      if (error.response?.status === 401) {
        userStorage.setNeedLogIn()
      }
      console.error(error);
      return null;
    });
}

export function patch<T>(url: string, config: any = {}): Promise<T | null> {
  return axios.patch(url,
    {
      ...config,
      headers: {
        ...config.headers,
      },
    },
  ).then((response) => {
    return response.data
  })
    .catch((error) => {
      if (error.response?.status === 401) {
        userStorage.setNeedLogIn()
      }
      console.error(error);
      return null;
    });
}

export default {
  get,
  post,
  put,
  del,
  patch,
}
